import { useTranslation } from 'react-i18next';
import { getRestApiUrl } from '@anytag/shared-utils';
import { useDownloadFile } from '@anytag/shared-hooks';
import { DownloadButton, Form } from '@anytag/shared-atoms';
import { TextSearchField } from '@anytag/shared-molecules';
import { AutoManagedJoinedInfluencersFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
  totalRecords?: number;
  autoManagedCampaignId: number;
}

export const Template = ({ onSubmit, totalRecords, autoManagedCampaignId }: TemplateProps) => {
  const { t } = useTranslation();
  const { downloading, handleDownloadFile } = useDownloadFile();

  return (
    <Form.Fields>
      <TextSearchField<AutoManagedJoinedInfluencersFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.InfluencerFilter')}
      />

      <Form.Field className="flex-none">
        <DownloadButton
          loading={downloading}
          disabled={!totalRecords}
          css={{ minWidth: '115px', textTransform: 'none' }}
          onClick={() =>
            handleDownloadFile({
              filenamePrefix: 'joined_influencers',
              url: getRestApiUrl(`auto_managed/${autoManagedCampaignId}/joined_influencers/csv/`)
            })
          }
        />
      </Form.Field>
    </Form.Fields>
  );
};
